import styled from 'styled-components';
import { YELLOW_HIGHLIGHT } from '../../utils/colours';

export const Highlight = styled.mark`
    background: ${YELLOW_HIGHLIGHT};
`;

Highlight.displayName = 'Highlight';